import { FileText } from "lucide-react";
import { PageHeader, EmptyState } from "@/components/common";
import { FiscalRoutes } from "@/fiscal";
import { useAuth } from "@/context/AuthContext";
import { canSee } from "@/lib/api";

export default function Fiscal() {
  const { session } = useAuth();
  if (!canSee(session.user, "fiscal")) {
    return <EmptyState icon={FileText} title="Sem acesso ao módulo fiscal" text="Disponível para Dono, Administrador e Gerente nos planos com o módulo Fiscal." />;
  }
  return (
    <>
      <PageHeader eyebrow="NF-e · NFC-e · NFS-e" title="Fiscal" subtitle="Emissão de notas fiscais direto do sistema" />
      <div className="rounded-xl border bg-white text-gray-900" data-testid="fiscal-module"><FiscalRoutes /></div>
    </>
  );
}
